// Module
var code = "<dls-button theme=\"coral\" size=\"medium\" ng-click=\"CardRequest.showCards()\"> Print cards </dls-button> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/cards/cardRequest/_printCards.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;